import { StudentResults } from '@yandex-int/k-common';
import { RoundedPlate, Switch, Text } from 'platform-components';
import React from 'react';
import { useDispatch } from 'react-redux';

import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import { LessonProblemWithResult } from 'common.components/student-lesson-stat/typings';

import { lessonContentActions } from '../actions';
import { useLessonContentSelector } from '../selectors';
import { getShouldHideAnswerControls } from '../utils';

import './lesson-content__answer-controls.scss';

interface Props {
    problems: Array<LessonProblemWithResult>;
    studentResults: StudentResults | null;
}

export const LessonContentAnswerControls = ({ problems, studentResults }: Props) => {
    const dispatch = useDispatch();
    const expandedProblemId = useLessonContentSelector((s) => s.expandedProblemId);
    const answerControlChecked = useLessonContentSelector((s) => {
        return s.expandedProblemId && s.expandedProblemId in s.showCorrectAnswersForProblems;
    });

    const studentProblemResult = (expandedProblemId && studentResults?.problems[expandedProblemId]) || null;
    const problemLink = problems.find((p) => p.id === expandedProblemId);
    const showAnswerControls = problemLink && !getShouldHideAnswerControls(problemLink, studentProblemResult);
    const onChange = () => {
        if (expandedProblemId !== null) {
            dispatch(lessonContentActions.toggleShowCorrectAnswer({ problemId: expandedProblemId }));
        }
    };

    if (!showAnswerControls) {
        return null;
    }

    return (
        <div className="lesson-content__answer-controls">
            <RoundedPlate mix="lesson-content__answer-controls-panel">
                <div className="lesson-content__answer-controls-label" {...accessibleClick(onChange)}>
                    <Text id="lessonContent.problem.showAnswer" size={Text.SIZE.XL} weight={Text.WEIGHT.M} />
                </div>
                <Switch
                    checked={answerControlChecked}
                    onChange={onChange}
                    size={Switch.SIZES.M}
                    theme={Switch.THEMES.LIGHT_BLUE}
                    view={Switch.VIEWS.INVERSE}
                />
            </RoundedPlate>
        </div>
    );
};
